import React from "react"
import { FileGallery } from "core/file-gallery"

export const ImageUpload = ({ active, onSelect }) => {
  return (
    <FileGallery
      active={active}
      onClose={onSelect}
      allowedFileTypes={["image"]}
    />
  )
}
